export default __webpack_public_path__ + "static/media/img_filterNoData_taboola.ed57cab2.svg";